import React from "react";
import { Stack, Typography, Button, TextField } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import CommonDialog from "../../../common/CommonDialog";
import { LANG } from "./constants";

const Dialogs = ({
  lang,
  deleteDialog,
  setDeleteDialog,
  handleDeleteConv,
  renameDialog,
  setRenameDialog,
  handleRenameConv,
}) => {
  return (
    <>
      <CommonDialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, conv: null })}
        title={lang?.deleteConversation || LANG.deleteConversation}
        icon={DeleteIcon}
        maxWidth="xs"
      >
        <Stack spacing={3}>
          <Typography variant="body2" color="text.secondary">
            {lang?.confirmDelete || LANG.confirmDelete}
          </Typography>

          <Stack direction="row" spacing={1.5} justifyContent="flex-end">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setDeleteDialog({ open: false, conv: null })}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 500 }}
            >
              {lang?.cancel || LANG.cancel}
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteConv}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              {lang?.delete || LANG.delete}
            </Button>
          </Stack>
        </Stack>
      </CommonDialog>

      <CommonDialog
        open={renameDialog.open}
        onClose={() => setRenameDialog({ open: false, conv: null, value: "" })}
        title={lang?.renameConversation || LANG.renameConversation}
        icon={EditIcon}
        maxWidth="xs"
      >
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoFocus
            label={lang?.newTitle || LANG.newTitle}
            value={renameDialog.value}
            onChange={(e) =>
              setRenameDialog((p) => ({ ...p, value: e.target.value }))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") handleRenameConv();
            }}
            inputProps={{ maxLength: 200 }}
          />

          <Stack direction="row" spacing={1.5} justifyContent="flex-end">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() =>
                setRenameDialog({ open: false, conv: null, value: "" })
              }
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 500 }}
            >
              {lang?.cancel || LANG.cancel}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={handleRenameConv}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              {lang?.rename || LANG.rename}
            </Button>
          </Stack>
        </Stack>
      </CommonDialog>
    </>
  );
};

export default Dialogs;
